import { useLocation, useNavigate } from 'react-router-dom';
import type { NavigationItem, NavigationSection, User } from '../types';
import { checkSectionAccess } from '../utils/accessControl';

export const useNavigation = (currentUser: User | null) => {
    const location = useLocation();
    const navigate = useNavigate();

    const currentSection: NavigationSection = (() => {
        const path = location.pathname;
        if (path.startsWith('/users')) return 'users';
        if (path.startsWith('/suppliers')) return 'suppliers';
        if (path.startsWith('/clients')) return 'clients';
        if (path.startsWith('/categories')) return 'categories';
        if (path.startsWith('/diagnostics')) return 'diagnostics';
        if (path.startsWith('/products')) return 'products';
        if (path.startsWith('/attributes')) return 'attributes';
        if (path.startsWith('/b2b-clients')) return 'b2b-clients';
        if (path.startsWith('/shop-companies')) return 'shop-companies';
        if (path.startsWith('/shop-orders')) return 'shop-orders';
        if (path.startsWith('/maintenance')) return 'maintenance';
        if (path.startsWith('/operations')) return 'operations';
        if (path.startsWith('/smtp')) return 'smtp';
        if (path.startsWith('/order-lifetime')) return 'order-lifetime';
        return 'integrations';
    })();

    const navigationItems: NavigationItem[] = [
        { key: 'integrations', label: 'Интеграции' },
        { key: 'categories', label: 'Категории' },
        { key: 'products', label: 'Продукты' },
        { key: 'attributes', label: 'Атрибуты' },
        { key: 'b2b-clients', label: 'B2B клиенты' },
        {
            label: 'Покупатели',
            icon: 'bi-bag-fill',
            children: [
                { key: 'shop-companies', label: 'Компании' },
                { key: 'shop-orders', label: 'Заказы' }
            ]
        },
        { key: 'maintenance', label: 'Обслуживание' },
        { key: 'operations', label: 'Операции' },
        { key: 'suppliers', label: 'Поставщики' },
        { key: 'diagnostics', label: 'Диагностика' },
        {
            label: 'Администрирование',
            icon: 'bi-shield-lock-fill',
            children: [
                { key: 'users', label: 'Пользователи' },
                { key: 'smtp', label: 'SMTP' },
                { key: 'order-lifetime', label: 'Время жизни заказов' }
            ]
        }
    ];

    const filteredNavigationItems = navigationItems
        .map(item => {
            if (!item.children) {
                return item.key && checkSectionAccess(item.key, currentUser) ? item : null;
            }
            return { ...item, children: item.children.filter(child => checkSectionAccess(child.key, currentUser)) };
        })
        .filter((item): item is NavigationItem =>
            item !== null && (!item.children || item.children.length > 0));

    const handleSectionChange = (section: NavigationSection) => {
        navigate(`/${section}`);
    };

    return {
        currentSection,
        navigationItems: filteredNavigationItems,
        handleSectionChange,
    };
};
